<script>
    const global = {
        // 屏幕高度
        windowHeight : document.documentElement.clientHeight,
        deviceWidth : document.documentElement.clientWidth,
    };

    // 可视窗口高度
    if (global.deviceWidth > 750) {
        global.deviceWidth = 750;
    }
    // 换算出可视窗口高度的rem数值
    global.clientHeight = global.windowHeight / parseFloat(global.deviceWidth / 7.5);

    export default{
        global
    }
</script>


// WEBPACK FOOTER //
// src/components/Global.vue